<div class="user-details">
  <div class="user-details__list">
    <div *ngFor="let detail of detailsList" class="cell">
      <div class="cell__title">{{detail.title}}</div>
      <div class="cell__text">{{detail.text}}</div>
    </div>
  </div>
</div>
